import { adminCopy } from "./copy/admin";
import { credentialCopy, loginCopy, passwordCopy } from "./copy/auth";
import { recentChecks } from "./copy/referenceData";
import { loadingCopy, topbarCopy } from "./copy/shell";
import { libraryCopy, savedCopy, searchCopy, sidebarCopy } from "./copy/workspace";

export const appContent = {
  topbar: topbarCopy,
  loading: loadingCopy,
  credentials: credentialCopy,
  login: loginCopy,
  password: passwordCopy,
  sidebar: sidebarCopy,
  admin: adminCopy,
  library: libraryCopy,
  saved: savedCopy,
  search: searchCopy
} as const;

export { recentChecks };
